import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { S3UploadFile } from '@/types/unlock'

const baseQueryAuth = (baseQueryConfig) => {
  const baseQuery = fetchBaseQuery(baseQueryConfig)
  return async (args, api, extraOptions) => {
    const response = await baseQuery(args, api, extraOptions)
    if (!args?.url?.includes('/logout/') && response.error && response.error.status === 401) {
      window.location.href = '/login'
    }
    return response
  }
}

export const s3Api = createApi({
  reducerPath: 's3Api',

  baseQuery: baseQueryAuth({}),

  endpoints: (builder) => ({
    uploadFile: builder.mutation<{ error: object; data: object }, S3UploadFile>({
      query: ({ url, file }) => {
        return {
          method: 'PUT',
          url: url,
          body: file,
        }
      },
    }),
  }),
})

export const { useUploadFileMutation } = s3Api
